import { CreateTagReq, UpdateTagReq } from '../dto/ReqDtoRepository';
import { SimpleStringResponse, TagListResponse, TagResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';

export const getTextTagList = async (aui: string): Promise<TagListResponse> => {
  return sendGetApiRequest<TagListResponse>(`/api/v1/text-tag/list?aui=${encodeURIComponent(aui)}`);
};

export const createTextTag = async (aui: string, data: CreateTagReq): Promise<TagResponse> => {
  return sendApiRequest<TagResponse>('post', `/api/v1/text-tag?aui=${encodeURIComponent(aui)}`, data);
};

export const updateTextTag = async (aui: string, data: UpdateTagReq): Promise<TagResponse> => {
  return sendApiRequest<TagResponse>('put', `/api/v1/text-tag?aui=${encodeURIComponent(aui)}`, data);
};

export const deleteTextTag = async (aui: string, tagId: number): Promise<SimpleStringResponse> => {
  return sendDeleteApiRequest<SimpleStringResponse>(
    `/api/v1/text-tag?aui=${encodeURIComponent(aui)}&tagId=${encodeURIComponent(String(tagId))}`
  );
};
